module.exports = __webpack_public_path__ + "static/img/mi10Pro.ffa36920.png";